import { createElement, isNullOrUndefined, Browser, print as printWindow } from '@syncfusion/ej2-base';
import { PdfPageOrientation, PdfDocument, PdfBitmap } from '@syncfusion/ej2-pdf-export';
import { SvgRenderer } from '@syncfusion/ej2-svg-base';
import { removeElement } from '../utils/helper';
import { SizeF } from '@syncfusion/ej2-pdf-export';
export class ExportUtils {
    /**
     * Constructor for Heatmap
     *
     * @param  {HeatMap} control - specifies the control
     *
     */
    constructor(control) {
        this.control = control;
    }
    /**
     * To export the file as image/svg format
     *
     * @param type
     * @param fileName
     * @private
     */
    export(type, fileName, orientation) {
        const controlValue = this.getControlsValue();
        const width = controlValue.width;
        const height = controlValue.height;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let element = this.control.svgObject;
        let url;
        const isCanvas = this.control.enableCanvasRendering;
        let image;
        if (!isCanvas) {
            element = createElement('canvas', {
                id: 'ej2-canvas',
                attrs: {
                    'width': width.toString(),
                    'height': height.toString()
                }
            });
        }
        const isDownload = !(Browser.userAgent.toString().indexOf('HeadlessChrome') > -1);
        orientation = isNullOrUndefined(orientation) ? PdfPageOrientation.Landscape : orientation;
        const svgData = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
            controlValue.svg.outerHTML +
            '</svg>';
        if (!isCanvas) {
            const exportElement = this.control.svgObject.cloneNode(true);
            const backgroundElement = exportElement.childNodes[0];
            const backgroundColor = backgroundElement.getAttribute('fill');
            if ((this.control.theme === 'Tailwind' || this.control.theme === 'Tailwind3' || this.control.theme === 'Bootstrap5' || this.control.theme === 'Fluent' || this.control.theme === 'Material3' || this.control.theme === 'Fluent2')
                && (backgroundColor === 'rgba(255,255,255, 0.0)' || backgroundColor === 'transparent')) {
                backgroundElement.setAttribute('fill', 'rgba(255,255,255, 1)');
            }
            else if ((this.control.theme === 'TailwindDark' || this.control.theme === 'Tailwind3Dark' || this.control.theme === 'Bootstrap5Dark' || this.control.theme === 'FluentDark' || this.control.theme === 'Material3Dark' ||
                this.control.theme === 'Fluent2Dark' || this.control.theme === 'Fluent2HighContrast')
                && (backgroundColor === 'rgba(255,255,255, 0.0)' || backgroundColor === 'transparent')) {
                backgroundElement.setAttribute('fill', 'rgba(0, 0, 0, 1)');
            }
            url = window.URL.createObjectURL(new Blob(type === 'SVG' ? [svgData] :
                [(new XMLSerializer()).serializeToString(exportElement)], { type: 'image/svg+xml' }));
        }
        else {
            url = element.toDataURL('image/png');
        }
        if (type === 'SVG') {
            if (Browser.info.name === 'msie') {
                const svg = new Blob([(new XMLSerializer()).serializeToString(controlValue.svg)], { type: 'application/octet-stream' });
                if (!isNullOrUndefined(window.navigator.msSaveOrOpenBlob)) {
                    window.navigator.msSaveOrOpenBlob(svg, fileName + '.' + type.toLocaleLowerCase());
                }
            }
            else {
                this.triggerDownload(fileName, type, url, isDownload);
            }
        }
        else if (Browser.info.name === 'msie') {
            let canvas = element;
            if (!isCanvas) {
                canvas = this.createCanvas();
            }
            image = canvas.toDataURL(type);
            if (type === 'PDF') {
                this.exportPdf(canvas, orientation, width, height, isDownload, fileName);
            }
            else {
                this.doExport(type, image, fileName);
            }
        }
        else {
            const image = new Image();
            const ctx = element.getContext('2d');
            const backgroundColor = ctx.shadowColor;
            image.onload = (() => {
                if ((this.control.theme === 'Tailwind' || this.control.theme === 'Tailwind3' || this.control.theme === 'Bootstrap5'
                    || this.control.theme === 'Fluent' || this.control.theme === 'Material3' || this.control.theme === 'Fluent2')
                    && (backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === 'transparent')) {
                    ctx.fillStyle = 'rgba(255,255,255, 1)';
                }
                else if ((this.control.theme === 'TailwindDark' || this.control.theme === 'Tailwind3Dark' ||
                    this.control.theme === 'Bootstrap5Dark' || this.control.theme === 'FluentDark' || this.control.theme === 'Material3Dark'
                    || this.control.theme === 'Fluent2Dark' || this.control.theme === 'Fluent2HighContrast')
                    && (backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === 'transparent')) {
                    ctx.fillStyle = 'rgba(0, 0, 0, 1)';
                }
                ctx.fillRect(0, 0, element.width, element.height);
                ctx.drawImage(image, 0, 0);
                window.URL.revokeObjectURL(url);
                if (type === 'PDF') {
                    this.exportPdf(element, orientation, width, height, isDownload, fileName);
                }
                else {
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(element.msToBlob(), fileName + '.' + type.toLocaleLowerCase());
                    }
                    else {
                        this.triggerDownload(fileName, type, element.toDataURL('image/png').replace('image/png', 'image/octet-stream'), isDownload);
                    }
                }
            });
            image.src = url;
        }
        if (!isCanvas) {
            const id = document.getElementById(this.control.element.id);
            removeElement(id + '_canvas');
        }
    }
    /**
     * To trigger the download element
     *
     * @param fileName
     * @param type
     * @param url
     * @private
     */
    triggerDownload(fileName, type, url, isDownload) {
        createElement('a', {
            attrs: {
                'download': fileName + '.' + type.toLocaleLowerCase(),
                'href': url
            }
        }).dispatchEvent(new MouseEvent(isDownload ? 'click' : 'move', {
            view: window,
            bubbles: false,
            cancelable: true
        }));
    }
    /**
     * To get the maximum size value
     *
     * @param controls
     * @param name
     */
    getControlsValue() {
        let width = 0;
        let height = 0;
        const isCanvas = this.control.enableCanvasRendering;
        const svgObject = new SvgRenderer('').createSvg({
            id: 'Svg_Export_Element',
            width: 200, height: 200
        });
        const svg = this.control.svgObject.cloneNode(true);
        const groupEle = this.control.renderer.createGroup({});
        groupEle.style.cssText = 'transform: translateY(' + height + 'px)';
        if (!isCanvas) {
            groupEle.appendChild(svg);
        }
        width = Math.max(this.control.availableSize.width, width);
        height = height + this.control.availableSize.height;
        if (!isCanvas) {
            svgObject.appendChild(groupEle);
        }
        if (!isCanvas) {
            svgObject.setAttribute('width', width + '');
            svgObject.setAttribute('height', height + '');
        }
        return {
            'width': width,
            'height': height,
            'svg': svgObject
        };
    }
    createCanvas() {
        const heatmap = this.control;
        const renderMode = heatmap.renderingMode;
        heatmap.renderingMode = 'Canvas';
        heatmap.refresh();
        const canvas = heatmap.svgObject;
        heatmap.renderingMode = renderMode;
        heatmap.refresh();
        return canvas;
    }
    exportPdf(element, orientation, width, height, isDownload, fileName) {
        const document = new PdfDocument();
        const margin = document.pageSettings.margins;
        const pdfDefaultWidth = document.pageSettings.width;
        const pdfDefaultHeight = document.pageSettings.height;
        let imageString = element.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');
        document.pageSettings.orientation = orientation;
        const exactWidth = (pdfDefaultWidth < width) ? (width + margin.left + margin.right) : pdfDefaultWidth;
        const exactHeight = (pdfDefaultHeight < height) ? (height + margin.top + margin.bottom) : pdfDefaultHeight;
        document.pageSettings.size = new SizeF(exactWidth, exactHeight);
        imageString = imageString.slice(imageString.indexOf(',') + 1);
        document.pages.add().graphics.drawImage(new PdfBitmap(imageString), 0, 0, width, height);
        if (isDownload) {
            document.save(fileName + '.pdf');
            document.destroy();
        }
    }
    doExport(type, image, fileName) {
        let images = [];
        const fileType = type || 'JPG';
        images = [image];
        this.exportImage(images, fileName, fileType, image);
    }
    exportImage(images, fileName, fileType, image) {
        const buffers = [];
        const length = (!(images instanceof HTMLElement)) ? images.length : 0;
        for (let g = 0; g < length; g++) {
            image = images[g];
            image = image.replace(/^data:[a-z]*;,/, '');
            const image1 = image.split(',');
            const byteString = atob(image1[1]);
            const buffer = new ArrayBuffer(byteString.length);
            const intArray = new Uint8Array(buffer);
            for (let i = 0; i < byteString.length; i++) {
                intArray[i] = byteString.charCodeAt(i);
            }
            buffers.push(buffer);
        }
        for (let j = 0; j < buffers.length; j++) {
            const b = new Blob([buffers[j]], { type: 'application/octet-stream' });
            if (Browser.info.name === 'msie' && !isNullOrUndefined(window.navigator.msSaveOrOpenBlob)) {
                window.navigator.msSaveOrOpenBlob(b, fileName + '.' + fileType.toLocaleLowerCase());
            }
        }
    }
    /**
     * To print the heatmap elements.
     *
     * @param elements
     * @private
     */
    print() {
        this.printWindow = window.open('', 'print', 'height=' + window.outerHeight + ',width=' + window.outerWidth + ',tabbar=no');
        this.printWindow.moveTo(0, 0);
        this.printWindow.resizeTo(screen.availWidth, screen.availHeight);
        if (this.control.renderingMode === 'SVG') {
            printWindow(this.getHTMLContent(), this.printWindow);
        }
        else {
            const element = this.control.svgObject;
            const dataUrl = element.toDataURL();
            const image = new Image();
            const ctx = element.getContext('2d');
            image.onload = (() => {
                ctx.drawImage(image, 0, 0);
            });
            image.src = dataUrl;
            printWindow(image, this.printWindow);
        }
    }
    /**
     * To get the html string of the heatmap.
     *
     * @param elements
     * @private
     */
    getHTMLContent() {
        const div = createElement('div');
        div.appendChild(this.control.element.cloneNode(true));
        return div;
    }
}
